<template>
  <div class="referral-chain" @touchmove.stop="closeShowTips">
    <ul>
      <template v-for="(item, index) in referralChainInfo" >
        <li :key="'hardlink' + index">
          <div :class="{icon_pc_style : isPc}" v-if="index - 1 <= selfIndex && index > 0" class="referral-icon">
          <span class="iconfont icona-hardlink"></span>
          </div>
          <div :class="{icon_pc_style : isPc}" v-if="index - 1 > selfIndex" class="referral-icon">
          <span class="iconfont icona-softlink"></span>
          </div>
        </li>
        <li :key="index">
          <div class="candidate-info" :class="{ 'candidate-info-pc' : isPc }" style="--breath-color: #0296cc">
            <div
              v-if="!isAppliedList && (index - selfIndex) === 1"
              class="can-share"
              :class="{ 'breath-animation': index !== (referralChainInfo.length - 1) || !isAppliedList }"
              :style="index !== (referralChainInfo.length - 1) && `--breath-color: var(--custom-color)`">
              <img
                v-clickoutside="() => closeShowTips(index)"
                class="referral-chain-photo"
                :class="{ self: index === referralChainInfo.length - 1 }"
                :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url]"
                @error="getDefaultProfilePhoto($event)"
                @click="onImgClick(index, $event)"
              />
              <div v-if="index !== (referralChainInfo.length - 1) || !isAppliedList" class="share-icon" >
                <van-icon name="share" />
              </div>
            </div>
            <div
              v-else-if="!isAppliedList && (index - selfIndex) < 3 && (index - selfIndex) > 0"
              class="can-share"
              :class="index === (referralChainInfo.length - 1) && 'breath-animation'"
            >
              <img
                v-clickoutside="() => closeShowTips(index)"
                class="referral-chain-photo"
                :class="{ self: index === referralChainInfo.length - 1 }"
                :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url]"
                @error="getDefaultProfilePhoto($event)"
                @click="onImgClick(index, $event)"
              />
            </div>
            <div v-else :class="!isAppliedList && index === (referralChainInfo.length - 1) && 'breath-animation'">
              <img
                class="referral-chain-photo"
                :class="{ self: index === (referralChainInfo.length - 1) }"
                :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url]"
                @error="getDefaultProfilePhoto($event)"
                @click="onImgClick(index, $event)"
              />
            </div>
            <span class="candidate-name" :title="item.name">{{ item.name }}</span>
            <span>{{ isEn() ? item.city?.name : item.city?.cn_name }}</span>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { isEn } from '@/i18n'

export default {
  directives: {
    Clickoutside
  },
  props: {
    referralChainInfo: {
      type: Array,
      require: true
    },
    jobId: {
      type: Number,
      require: true
    },
    isPc: {
      type: Boolean,
      default: false
    },
    shortUniqueId: {
      type: String,
      require: true
    },
    isAppliedList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isEn,
      selfIndex: 2,
      showTips: false,
      showTipsIndex: null
    }
  },
  computed: {

  },
  created () {
    this.referralChainInfo.forEach((element, index) => {
      if (element.self === true) {
        this.selfIndex = index
      }
    })
  },
  methods: {
    closeShowTips (index) {
      if (this.showTips && index === this.showTipsIndex) {
        this.showTips = false
      }
      this.$emit('closeShowTips')
    },
    onImgClick (index, $event) {
      if (this.isAppliedList) {
        return
      }
      const isAfterSelf = (index - this.selfIndex) === 1
      const isLast = index === (this.referralChainInfo.length - 1)
      if (!isAfterSelf && !isLast) {
        return
      }
      if (this.isPc || (this.showTips && index === this.showTipsIndex)) {
        this.toJobDetailPage()
      } else {
        this.showTips = true
        this.showTipsIndex = index
        this.$emit('showShareTip', {
          content: this.$t('personal.referrals.leads.message.shareTip'),
          clientRect: $event.target.getBoundingClientRect()
        })
      }
    },
    toJobDetailPage () {
      if (this.isPc) {
        window.location.href = this.$DjangoBaseUrl(`/job-detail-new/${this.jobId}/c/`)
      } else {
        this.$router.push(`/job-description/${this.shortUniqueId}`)
      }
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-chain {
  padding-top: 10px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(204, 211, 211, 1);
    background: rgba(152, 155, 163, 0.5);
  }

  >ul {
    display: flex;
    align-items: flex-start;

    .referral-icon {
      width: 32px;
      height: 32px;
      position: relative;
      margin-bottom: 43px;

      > span {
       font-size: 35px;
       color: rgb(2, 150, 204);
      }
    }

    >li {
      text-align: center;
      display: flex;
      height: 80px;
      margin-bottom: 5px;
      padding: 0px 5px 0px 5px;

      .candidate-info {
        display: flex;
        flex-direction: column;
        align-items: center;

        > div {
          margin-top: 2px;
          border-radius: 50%;
          height: 42px;
        }

        .referral-chain-photo {
          border: 1px solid white;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          box-shadow: 2px 1px 4px 0px #a8b2b5;
          z-index: 1;
        }

        .self {
          box-shadow: 0 0 0px 2px #0296cc;
        }

        .can-share {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          position: relative;
          border: 2px solid var(--custom-color);

          > img {
            margin: 0;
            width: 38px;
            height: 38px;
          }
        }

        .share-icon {
          width: 16px;
          height: 16px;
          background: var(--custom-color);
          border-radius: 50%;
          bottom: -2px;
          right: -2px;
          color: #FFFFFF;
          z-index: 2;
          position: absolute;

          > i {
            font-size: 14px;
          }

        }

        .share-tips {
          z-index: 2;
          position: absolute;
        }

        span {
          font-size: 10px;
          white-space: nowrap;
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          margin: 0px;
        }

        .candidate-name {
          color: #333333;
          font-size: 12px;
          margin-top: 5px;
          line-height: 16px;
        }
      }

      .candidate-info-pc {
        display: flex;
        flex-direction: column;
        align-items: center;

        .can-share {
          width: 42px;
          height: 42px;
        }
      }

      .pc_style {
        padding-top: 2px;
        width:70px;
        text-align: center;
        display: inline-block;
        white-space: nowrap;
        vertical-align: top;
        align-items: flex-start;

        .referral-chain-photo {
          width: 40px;
          height: 40px;
          border-radius: 0;
          box-shadow: 0;
          -webkit-box-shadow: 0;
        }

        > p {
          height: 14px;
          font-size: 10px;
          font-weight: 500;
          line-height: 14px;
          margin-top: 5px;
        }
      }

      .icon_pc_style {
        margin-top: 2px;
      }
    }
  }

  .breath-animation {
    box-shadow: 0 0 10px -3px var(--breath-color);
    animation: breath 3s linear infinite;
  }

  @keyframes breath {
    from {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
    25% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    50% {
      opacity: 1;
      box-shadow: 0 0 8px 2px var(--breath-color);
    }
    75% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    to {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
  }
}
</style>
